import React from "react";
import { Route } from "react-router-dom";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import LogIn from "../containers/LogIn";
import Account from "../containers/Account";
import AdminUser from "../containers/AdminUser";
import AdminDetail from "../containers/Account/Detail";
import Dvir from "../containers/Dvir";
import DvirDetail from "../containers/Dvir/DvirDetail";
import Document from "../containers/Document";
import Fmcsa from "../containers/Fmcsa";
import FmcsaHistory from "../containers/Fmcsa/FmcsaHistory";
import Report from "../containers/Report";
import Setting from "../containers/Setting";
import SettingApp from "../containers/Setting/SettingApp";
import SettingProfile from "../containers/Setting/Profile";
import SettingAccount from "../containers/Setting/SettingAccount";
import SettingEditReason from "../containers/Setting/SettingEditReason";
import SettingExceptions from "../containers/Setting/SettingExceptions";
import SettingUser from "../containers/Setting/User";
import NotificationSetup from "../containers/Setting/NotificationSetup";
import DriverDetails from "../containers/Setting/User/DriverDetails";
import Violations from "../containers/Violations";
import DailyDiary from "../containers/DailyDiary";
import DailyStatusDetail from "../containers/DailyStatus";
import DailyStatusMulti from "../containers/DailyStatus/DailyStatusMulti";
import VerifyLogs from "../containers/DailyStatus/VerifyLogs";
import ReviewLogs from "../containers/DailyStatus/ReviewLogs";
import Notifications from "../containers/Notifications";
import LogEdits from "../containers/LogEdits";
import Webview from "../containers/WebView/Webview";
import DailyCurrentGMaps from "../containers/DailyCurrentGMaps";


const styles = {
  mainContent: {
    flex: 1,
    padding: "0px",
    maxWidth: "100%",
    overflow: "scroll",
  },
};

function MainRoutes(props) {
  const { classes, accountBaseUrl } = props;

  return (
    <main className={classes.mainContent}>
      <Route exact path="/" component={LogIn} />

      <Route exact path={`/dashboard/admin-users`} component={AdminUser} />
      <Route
        exact
        path={`/dashboard/accounts`}
        component={Account}
      />
      <Route
        exact
        path={`/dashboard/accounts/:accountId`}
        component={AdminDetail}
      />

      <Route
        exact
        path={`${accountBaseUrl}/webview/:driverId`}
        component={Webview}
      />

      <Route
        exact
        path={`${accountBaseUrl}/status/view`}
        component={DailyCurrentGMaps}
      />

      <Route
        exact
        path={`${accountBaseUrl}/status/diary/:driverId`}
        component={DailyDiary}
      />

      <Route
        exact
        path={`${accountBaseUrl}/status/detail/:driverId`}
        component={DailyStatusDetail}
      />
      <Route
        exact
        path={`${accountBaseUrl}/status/multi/:driverId`}
        component={DailyStatusMulti}
      />
      <Route
        exact
        path={`${accountBaseUrl}/status/detail/:driverId/verify`}
        component={VerifyLogs}
      />
      <Route
        exact
        path={`${accountBaseUrl}/status/detail/:driverId/review`}
        component={ReviewLogs}
      />

      <Route exact path={`${accountBaseUrl}/dvir`} component={Dvir} />
      <Route
        exact
        path={`${accountBaseUrl}/dvir/:dvirId`}
        component={DvirDetail}
      />
      <Route exact path={`${accountBaseUrl}/document`} component={Document} />
      <Route exact path={`${accountBaseUrl}/fmcsa/create`} component={Fmcsa} />
      <Route
        exact
        path={`${accountBaseUrl}/fmcsa/history`}
        component={FmcsaHistory}
      />
      <Route exact path={`${accountBaseUrl}/log-edits`} component={LogEdits} />
      <Route
        exact
        path={`${accountBaseUrl}/violations`}
        component={Violations}
      />
      <Route
        exact
        path={`${accountBaseUrl}/notifications`}
        component={Notifications}
      />
      <Route path={`${accountBaseUrl}/report`} component={Report} />
      <Route
        exact
        path={`${accountBaseUrl}/report/fmcsa/create`}
        component={Fmcsa}
      />
      <Route
        exact
        path={`${accountBaseUrl}/report/document`}
        component={Document}
      />
  
      <Route path={`${accountBaseUrl}/settings`} component={Setting} />
      <Route
        exact
        path={`${accountBaseUrl}/settings/app`}
        component={SettingApp}
      />
      <Route
        exact
        path={`${accountBaseUrl}/settings/user`}
        component={SettingUser}
      />
      <Route
        exact
        path={`${accountBaseUrl}/settings/user/:driverId`}
        component={DriverDetails}
      />
      <Route
        exact
        path={`${accountBaseUrl}/settings/profile`}
        component={SettingProfile}
      />
      <Route
        exact
        path={`${accountBaseUrl}/settings/account`}
        component={SettingAccount}
      />
      <Route
        exact
        path={`${accountBaseUrl}/settings/exceptions`}
        component={SettingExceptions}
      />
      <Route
        exact
        path={`${accountBaseUrl}/settings/editreason`}
        component={SettingEditReason}
      />
      <Route
        exact
        path={`${accountBaseUrl}/settings/notification`}
        component={NotificationSetup}
      />
    </main>
  );
}

MainRoutes.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainRoutes);
